export default __webpack_public_path__ + "static/media/img-top-title-bg.a363162e.svg";